import React from "react";
import settingable from "fantastic/components/hoc/settingable";
import SingleNumberSetting from "fantastic/components/common/controls/SingleNumberSetting";

const SpacerSettings = ({ selected, update, selectedNode }) => {
  const onChange = (field, value) => {
    update(selected, { [field]: value.toString() });
  };

  const heightParams = {
    onChange,
    param: { field: "height", value: selectedNode.height }
  };
  return (
    <div>
      <SingleNumberSetting {...heightParams} />
    </div>
  );
};

export default settingable("background", "visibility", "border-color")(SpacerSettings);
